import { CompleteDtrManifestImportInput, CompleteDtrManifestImportResponse, LocationMapping } from '@/models/gen/graphql';

import { CompleteDtrManifestImportDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import graphApi from '@/api';

type CompleteDtrManifestImportGraphApiResponse = GraphApiResponse<typeof CompleteDtrManifestImportDocument>;

const completeDtrManifestImportResponseSelector = (res: CompleteDtrManifestImportGraphApiResponse): CompleteDtrManifestImportResponse =>
  !res.errors ? res?.CompleteDtrManifestImport : undefined;

const [runCompleteDtrManifestImport] = graphApi(CompleteDtrManifestImportDocument);

const completeDtrManifestImport = async (
  manifestImportId: string,
  locationMapping: LocationMapping[],
  tripIds: string[]
): Promise<CompleteDtrManifestImportResponse> => {
  const input: CompleteDtrManifestImportInput = {
    locationMapping,
    manifestImportId,
    tripIds,
  };

  const res = await runCompleteDtrManifestImport({ input });
  return completeDtrManifestImportResponseSelector(res);
};

export default completeDtrManifestImport;
